export const DEFAULT_COLOR = '#979797'
export const DEFAULT_FONT_COLOR = '#979797'
export const CIRCLE_ACTIVE_COLOR = '#197DF4'
export const LINE_DEFAULT_COLOR = '#979797'
